import type {
  AppointmentActionModalContextType,
  OpenFeedbackModalOptions,
} from 'contexts/modal/types';

/** Also known as the "eyeball" tool */
export const openAppointmentModal = (
  appointmentId: string,
  listingId: string,
  tabName:
    | 'history'
    | 'email'
    | 'sms'
    | 'push'
    | 'feedback'
    | 'covid' = 'history',
  options?: {
    additionalProps?: {
      onCovidAckSubmit?: (ackType: 'override' | 'upload') => void;
      openFeedbackModal?: (options: OpenFeedbackModalOptions) => void;
      onFeedbackModalSubmit?: () => void;
      openAppointmentActionModal?: AppointmentActionModalContextType['openModal'];
      onAppointmentActionModalConfirm?: () => void;
    };
  },
) => {
  const angularModalService: {
    openAppointmentModal: (
      appointmentId: string,
      listingId: string,
      tabType: any,
      options?: any,
    ) => void;
  } = angular.element(document).injector().get('ModalService');

  angularModalService.openAppointmentModal(
    appointmentId,
    listingId,
    tabName,
    options,
  );
};
